export class ComponentRect {

  locationX: number;
  locationY: number;

  height: number;
  width: number;

  static createFromClientRect(rect: ClientRect): ComponentRect {

    const componentRect = new ComponentRect();
    componentRect.locationX = this._fixZoom(rect.left);
    componentRect.locationY = this._fixZoom(rect.bottom);
    componentRect.width = this._fixZoom(rect.width);
    componentRect.height = this._fixZoom(rect.height);

    return componentRect;
  }

  private static _fixZoom(value: number): number {
    return Math.round(value * 1.3);
  }
}
